/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hour_Lower_Tiger_TypeInputs */

const fr_hour_lower_tiger_type = /** @type {(inputs: Hour_Lower_Tiger_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes séances`)
};

/**

* @param {Hour_Lower_Tiger_TypeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const hour_lower_tiger_type = /** @type {((inputs?: Hour_Lower_Tiger_TypeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hour_Lower_Tiger_TypeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_hour_lower_tiger_type(inputs)
});